export const labels = {
  es: {
    email: "Mail",
  },

  en: {
    email: "Email",
  },
};

export const titles = {
  es: {
    email: "Abrir una cuenta",
    validation: "Validá tu dirección de mail",
    stepper: "Validación",
  },
  en: {
    email: "Account opening",
    validation: "Validá tu dirección de mail",
    stepper: "Validation",
  },
};

export const placeholders = {
  es: {
    email: "direccion@mail.com",
  },
  en: {
    email: "address@email.com",
  },
};
